module.exports = __webpack_public_path__ + "static/masonry-image-6-6ae7f768df43c457cc5cc55d2a2a2cf5.jpg";